export const PPA_APPLICATION_DATA_REQUEST = 'PPA_APPLICATION_DATA_REQUEST';
export const PPA_APPLICATION_DATA_SUCCESS = 'PPA_APPLICATION_DATA_SUCCESS';
export const PPA_APPLICATION_DATA_FAIL = 'PPA_APPLICATION_DATA_FAIL';
